class FilterSelect {
	constructor() {
		this.filter = document.querySelector("#filterSelect");

		if (!this.filter) {
			return;
		}

		this.filterSelect();
	}

	filterSelect() {
		this.filter.addEventListener("change", (e) => {
			// redirect page to the selected value which should be an URL
			window.location	= e.target.value;
		});
	}
}
